import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import { borderRadius } from '@mui/system';
import { useState, useEffect } from 'react';

export default function BlogImageList() {

    const [width, setWidth] = useState(window.innerWidth)
    const [numCols, setNumCols] = useState(3)
    const [cardWidth, setCardWidth] = useState(370)

    useEffect(() => {
        const updateCardsPerPage = () => setWidth(window.innerWidth)
        if (width < 600) {
            setNumCols(1)
            setCardWidth(300)
        }
        else if (width < 900) {
            setNumCols(2)
        }

        return () => {
            window.removeEventListener("resize", updateCardsPerPage);
        }
    }, []);

    return (
        <ImageList sx={{ maxWidth: 1200, minHeight: 600 }} cols={numCols}>
            {itemData.map((item) => (
                <ImageListItem key={item.img} sx={{ borderRadius: 3, overflow: "hidden", width: cardWidth }}>
                    <img
                        srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                        src={`${item.img}?w=248&fit=crop&auto=format`}
                        alt={item.title}
                        loading="lazy"
                    />
                    <ImageListItemBar
                        title={item.title}
                        actionIcon={
                            <IconButton
                                sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                aria-label={`info about ${item.title}`}
                            >
                                <InfoIcon />
                            </IconButton>
                        }
                    />
                </ImageListItem>
            ))}
        </ImageList>
    );
}

const itemData = [
    {
        img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
        title: 'Breakfast',
        author: '@bkristastucchio',
    },
    {
        img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
        title: 'Burger',
        author: '@rollelflex_graphy726',
    },
    {
        img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
        title: 'Camera',
        author: '@helloimnik',
    },
    {
        img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
        title: 'Coffee',
        author: '@nolanissac',
    },
    {
        img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
        title: 'Hats',
        author: '@hjrc33',
    },
    {
        img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
        title: 'Honey',
        author: '@arwinneil',
    },
];
